import React from 'react';
import { Box } from '@mui/material';

const FlagIcon = ({ countryCode, sx }) => {
  const colors = {
    BE: ['#000000', '#FDDA24', '#EF3340'], // Belgique
    FR: ['#002395', '#FFFFFF', '#ED2939']  // France
  };

  const flagColors = colors[countryCode];

  if (!flagColors) return null;

  return (
    <Box sx={{ width: 24, height: 16, display: 'flex', ...sx }}>
      {flagColors.map((color, index) => (
        <Box key={index} sx={{ width: '33.3333%', height: '100%', backgroundColor: color }} />
      ))}
    </Box>
  );
};

export default FlagIcon;